import React from 'react';
import TextInput from './TextInput';

const JsonInput = ({ argument, onChange }) => {
  // JSON is essentially a multiline text input with JSON validation
  const jsonArgument = {
    ...argument,
    options: {
      ...argument.options,
      multiline: true,
      pattern: '^\\s*[\\{\\[].*[\\}\\]]\\s*$', // Basic JSON pattern
      errorMessage: 'Veuillez entrer un JSON valide',
    },
  };

  return <TextInput argument={jsonArgument} onChange={onChange} />;
};

export default JsonInput;
